import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, X } from "lucide-react";
import { api, errMsg } from "@/lib/api";

// Gentle nudge when a supporter still hasn't opened their link a week after being added
export const UnopenedSupporters = ({ compact = false, refresh }) => {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/supporters/unopened").then((r) => setList(r.data)).catch(() => {}); }, [refresh]);
  useEffect(() => { if (list.length && window.location.hash === "#unopened") document.getElementById("unopened")?.scrollIntoView({ behavior: "smooth", block: "center" }); }, [list.length]);
  if (!list.length) return null;
  const drop = (id) => setList((l) => l.filter((x) => x.id !== id));
  const resend = async (s) => { try { await api.post(`/supporters/${s.id}/invite`); toast.success(`Invite sent again to ${s.email}`); await api.post(`/supporters/${s.id}/reminder-dismiss`); drop(s.id); } catch (e) { toast.error(errMsg(e)); } };
  const dismiss = async (s) => { await api.post(`/supporters/${s.id}/reminder-dismiss`).catch(() => {}); drop(s.id); };
  return (
    <section id="unopened" className={`mm-card p-5 ${compact ? "mb-6" : "my-4"} mm-fade-up`} data-testid="unopened-supporters">
      <div className="font-semibold">{list.length === 1 ? `${list[0].name} hasn't opened their link yet` : `${list.length} supporters haven't opened their links yet`}</div>
      <p className="text-sm text-mm-muted mb-3">Emails sometimes land in spam or get missed. A quick resend often helps.</p>
      <div className="space-y-2">
        {list.map((s) => (
          <div key={s.id} className="mm-soft px-3 py-2 flex flex-wrap items-center gap-2 text-sm" data-testid={`unopened-${s.id}`}>
            <span className="flex-1 min-w-[10rem]"><b>{s.name}</b> · added {s.days} days ago</span>
            <button onClick={() => resend(s)} className="mm-chip" data-testid={`unopened-resend-${s.id}`}><Mail size={13} />Resend invite</button>
            <button onClick={() => dismiss(s)} className="p-1 text-mm-muted" aria-label="Dismiss" data-testid={`unopened-dismiss-${s.id}`}><X size={15} /></button>
          </div>
        ))}
      </div>
      {compact && <Link to="/supporters" className="text-sm text-mm-primary font-semibold mt-3 inline-block" data-testid="unopened-manage">Manage supporters</Link>}
    </section>
  );
};
